import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HeroBanner } from "./components/HeroBanner";
import { TeamSection } from "./components/TeamSection";
import { ContentSection } from "./components/ContentSection";
import { AboutSection } from "./components/AboutSection";
import { LocationSection } from "./components/LocationSection";
import { Footer } from "./components/Footer";

const Home = () => {
  return (
    <main className="min-h-screen">
      <HeroBanner />
      <TeamSection />
      <ContentSection />
      <AboutSection />
      <LocationSection />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
